module.exports = __webpack_public_path__ + "static/media/ding.a6ef9390.mp3";